import styled from "styled-components";

export const InputTagsContainer = styled.div`
    position: relative;
    width: 100%;
`;

export const InputTagsField = styled.input`
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #FFFFFF;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 48px;
    opacity: 0.67;
    outline: none;
    padding: 1.5rem 0.75rem 0.5rem 0.75rem;
    width: 100%;
    transition: height 0.2s ease-out;

    &::placeholder {
        color: #FFFFFF;
    }

    &:focus {
        filter: drop-shadow(2px 2px rgba(0,0,0,0.15));
        opacity: 1.0;
        height: 60px;
    }

    &:not(:placeholder-shown) {
        height: 60px;
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
        top: .5rem;
        font-size: 0.75rem;
        color: rgba(255,255,255,0.5);
        background-color: transparent;
    }
`;

export const InputLabel = styled.label`
    position: absolute;
    top: 1.1rem;
    left: 0.75rem;
    pointer-events: none;
    transition: all 0.2s ease-out;
    color: rgba(255,255,255,0.5);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 12px;
    font-weight: 500;
`;

export const TagsDisplay = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
`;

export const TagPill = styled.span`
    background: rgba(76, 175, 80, 0.2);
    border: 1px solid rgba(76, 175, 80, 0.4);
    border-radius: 12px;
    color: #4CAF50;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const TagRemoveButton = styled.button`
    background: none;
    border: none;
    color: #4CAF50;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    margin-left: 4px;
    
    &:hover {
        color: #ff6b6b;
    }
`;